<template>
  <div>
    <el-select
      v-model="field.selected_filter"
      @change="updateEntityData"
      clearable
      filterable
      remote
      :remote-method="searchEntityData"
      :placeholder="fieldPlaceholder"
      :size="size == 'mini' ? 'mini' : 'large'"
      :multiple="isMultiple ? true : false"
      collapse-tags
      :loading="loading"
      loading-text="Fetching data..."
      @clear="handleClear"
    >
      <el-option
        v-for="(temp, i) in allEntityDataList"
        :key="temp._id + '_' + i"
        :value="temp._id"
        :label="getLabel(temp, i)"
      >
        {{ getLabel(temp, i) }}
      </el-option>
      <el-option value="LOAD_MORE" v-if="hasMore">
        <span style="font-weight: bold">Load more...</span>
      </el-option>
    </el-select>
  </div>
</template>
<script>
  import moment from 'moment';
  import { postAPICall } from '@/helpers/httpHelper';
  import CustomDashboardConfig from '@/mixins/CustomDashboardHelper.js';
  import AutomationHelper from '@/mixins/AutomationHelper';
  import { fetchEntityById } from '@/repo/entityRepo';
  import moementTimezone from 'moment-timezone';
  export default {
    props: ['field', 'fieldPlaceholder', 'size', 'isMultiple', 'filters', 'primary_fields'],
    mixins: [CustomDashboardConfig, AutomationHelper],
    watch: {
      async field() {
        this.fetchEntityById(this.field.filter_field_entity_id);
      },
    },
    data() {
      return {
        currentEntity: null,
        loading: false,
        allEntityDataList: [],
        page: 1,
        hasMore: false,
        search_string: '',
      };
    },
    async mounted() {
      this.loading = true;
      await this.fetchEntityById(this.field.filter_field_entity_id);
      this.loading = false;
    },
    methods: {
      async searchEntityData(query) {
        this.loading = true;
        this.allEntityDataList = [];
        this.page = 1;
        this.search_string = query;
        await this.fetchEntitiesDataForTable(this.field.filter_field_entity_id);
      },
      async handleClear() {
        this.loading = true;
        this.allEntityDataList = [];
        this.page = 1;
        await this.fetchEntitiesDataForTable(this.field.filter_field_entity_id);
      },
      async updateEntityData() {
        if (this.field.selected_filter == 'LOAD_MORE') {
          this.field.selected_filter = [];
          this.page++;
          await this.fetchEntitiesDataForTable(this.field.filter_field_entity_id);
        } else {
          this.$emit('entityFilterUpdated', {
            entity_id: this.field.entity_id,
            value: this.field.selected_filter,
            filter: this.field,
          });
        }
        console.log('this.field.selected_Filter', this.field.selected_filter);
      },
      async fetchEntityById(entityId) {
        this.currentEntity = await fetchEntityById(entityId);
        this.allEntityFields = this.getAllFieldsFromEntity(this.currentEntity, false, false, true);
        await this.fetchEntitiesDataForTable(entityId);
      },
      async fetchEntitiesDataForTable(entityId) {
        let params = {
          entity_id: entityId,
          template_fields_data: this.currentEntity.templates.map((temp) => {
            return {
              template_id: temp.template_id,
              fields: this.primary_fields.length
                ? this.primary_fields
                    .filter((pf) => pf.split('#')[0] == temp.template_id)
                    .map((pf) => pf.split('#')[1])
                : this.currentEntity?.primaryFields?.[0].template_id == temp.template_id
                  ? [this.currentEntity?.primaryFields?.[0]?.key]
                  : [],
            };
          }),
          filters: this.filters || [],
          page: this.page,
          limit: 100,
          ...(this.search_string && {
            search_string: this.search_string,
            primary_search_fields: this.getPrimarySearchFields(),
          }),
        };
        const getEntityRecordsForTable = await postAPICall(
          'POST',
          '/entities-data/entity/data/v2',
          params
        );
        if (getEntityRecordsForTable) {
          this.allEntityDataList = [
            ...this.allEntityDataList,
            ...getEntityRecordsForTable.data.data,
          ];
          this.hasMore = getEntityRecordsForTable.data.hasMore;
          this.loading = false;
        } else {
          this.loading = false;
        }
      },
      getPrimarySearchFields() {
        let primaryFields = this.primary_fields.length
          ? this.primary_fields
          : [
              this.currentEntity.primaryFields[0].template_id +
                '#' +
                this.currentEntity.primaryFields[0].key,
            ];
        let extraFields = primaryFields.map((pf) => {
          let field = this.allEntityFields.find((fd) => fd.key == pf);
          switch (field.inputType) {
            case 'ENTITY':
            case 'INTEGRATION':
              return pf + '/name';
            case 'MASKED':
              return pf + '_masked';
            case 'PHONE_COUNTRY_CODE':
              return pf + '_code';
            case 'ADDRESS':
              return pf + '/values';
          }
        });
        return [
          ...primaryFields,
          ...extraFields.filter((fd) => ![undefined, null, ''].includes(fd)),
        ];
      },
      getField(key) {
        if (key && this.allEntityFields && this.allEntityFields.length) {
          return this.allEntityFields.find((e) => e.key == key);
        }
        return null;
      },
      getPrimaryLabel(primaryField, item) {
        let name = '';
        let key = primaryField && primaryField['key'] ? primaryField['key'] : null;
        if (key) {
          if (key.includes('#')) {
            key = key.split('#')[1];
          }
          let tempKey = primaryField.template_id + '#' + key;
          let data = item.templates_fields_data;
          name = data[tempKey] ? data[tempKey + '/name'] || data[tempKey] : '-';
          if (primaryField?.inputType == 'DATE') {
            name = moementTimezone(name).tz(this.timeZone.toString()).format('MM-DD-YYYY');
          } else if (primaryField?.inputType == 'DATE_TIME') {
            name = moementTimezone(name)
              .tz(this.timeZone.toString())
              .format('MM-DD-YYYY HH:mm:ss A');
          }
        }
        if (name && typeof name == 'object' && name.length) {
          return name.join(',');
        }
        return name;
      },
      getLabel(item, i) {
        let selectedEntity = this.currentEntity ? this.currentEntity : {};
        let name = 'data ' + i;
        if (this.primary_fields && this.primary_fields.length) {
          name = '';
          this.primary_fields.forEach((pr, index) => {
            let field = this.getField(pr);
            if (field && index < 3 && this.getPrimaryLabel(field, item)) {
              let separator = '';
              if (index != 0) {
                separator = ' - ';
              }
              name = name + separator + this.getPrimaryLabel(field, item);
            }
          });
        } else if (selectedEntity && selectedEntity.primaryFields) {
          let primaryField = selectedEntity.primaryFields[0];
          let tempKey = primaryField?.template_id + '#' + primaryField?.key;
          if (item?.templates_fields_data?.[tempKey]) {
            name =
              primaryField.inputType == 'ENTITY'
                ? item?.templates_fields_data?.[tempKey + '/name']
                : primaryField.input_type == 'DATE'
                  ? moment(item?.templates_fields_data?.[tempKey]).format(this.getDefaultDateFormat)
                  : primaryField.input_type == 'DATE_TIME'
                    ? moment(item?.templates_fields_data?.[tempKey]).format(
                        this.getDefaultDateFormat + ' HH:mm:ss'
                      )
                    : item?.templates_fields_data?.[tempKey];
          }
        }
        return name;
      },
    },
  };
</script>
